module.exports = __webpack_public_path__ + "img/hrc_thumb.06a7e259.webp";